import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initData } from './reducers/data';
import App from './components/App/App';
import './index.css';

// the id of the div to render too
let appId = "morningStarApp";

// set the apiURL from env variable
initParams.apiURL = `${process.env.REACT_APP_API_URL}`
initParams.version = `${process.env.REACT_APP_VERSION}`
initParams.name = `${process.env.REACT_APP_NAME}`
// default app params
//initParams.sampleParam = "sample param";

// optionally set param from URL param
//initParams.sampleParam = window.location.search.split('sampleParam=')[1] || initParams.sampleParam;

// optionally set param from window.portfolioMapper
/*
if(window.portfolioMapper) {
  initParams.sampleParam = window.portfolioMapper.sampleParam;
}
*/

// optionally load attributes from script tag
function getSyncScriptParams() {
  var scripts = document.getElementsByTagName('script');
  var lastScript = scripts[scripts.length - 1];
  var scriptName = lastScript;
  // override from attributes if they exist
  //if (scriptName.getAttribute('sampleParam')) initParams.sampleParam = scriptName.getAttribute('sampleParam');
  if (scriptName.getAttribute('appId')) appId = scriptName.getAttribute('appId');
  initParams.version = `${process.env.REACT_APP_VERSION}` ? `${process.env.REACT_APP_VERSION}` : 'VDEV';
}
getSyncScriptParams();

// render
ReactDOM.render((
  <Provider store={createStore(reducers, { "params": initParams, "data": initData }, applyMiddleware(thunk))}>
    <App />
  </Provider>
), document.getElementById(appId));


// WEBPACK FOOTER //
// ./src/index.js